import { render, staticRenderFns } from "./CabinPrice.vue?vue&type=template&id=5f3f9e04&"
import script from "./CabinPrice.ts?vue&type=script&lang=ts&"
export * from "./CabinPrice.ts?vue&type=script&lang=ts&"
import style0 from "./CabinPrice.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports